import { Layout } from 'antd';
import './GeneralFooter.less';
const { Footer } = Layout;

const GeneralFooter = () => {
    return (
        <Footer className="site-layout-footer">Gaming Admin ©2021</Footer>
    )
}

export default GeneralFooter;